import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import "../SafeHTMLRender/style.css";
import SafeHTMLRenderer from "../SafeHTMLRender/SafeHTMLRender";

interface MobilePreviewProps {
  imageUrl: string;
  description: string;
  message?: string;
  altText?: string;
}

const MobilePreview: React.FC<MobilePreviewProps> = ({
  imageUrl,
  description,
  message = "",
  altText = "Mobile Preview",
}) => {
  const showMessage = message?.trim()?.length > 0;

  return (
    <div
      className={tw`w-60 flex flex-col items-center justify-center text-sm text-gray-500 text-center p-4`}
    >
      <div className="relative w-full">
        <img src={imageUrl} alt={altText} className="w-full" />

        {showMessage && (
          <div
            className={tw`absolute left-4 top-14 flex items-start justify-start`}
          >
            <div
              className={tw`border rounded-2xl bg-gray-100 py-1 px-3 w-fit max-w-[175px] max-h-[350px] overflow-y-auto shadow`}
            >
              <div
                className={tw`text-black text-left text-xs break-words whitespace-pre-wrap`}
              >
                <SafeHTMLRenderer html={message} className="ProseMirror" />
              </div>
            </div>
          </div>
        )}
      </div>

      <p className={tw`mt-3`}>{description}</p>
    </div>
  );
};

export default MobilePreview;
